import React, { Component } from "react";
import Hero from "../components/Hero";
import HomeUserDescription from "../components/HomeUserDescription";

class NoMatchPage extends Component {
  componentWillMount() {
    document.title = "404";
  }
  render() {
    return (
      <div className="page-container container">
        <a name="skipnav" id="skipnav">
          <Hero title="404" subTitle="Page link requested not found." />
        </a>
        <div className="row  d-flex justify-content-center py-5">
          <div className="col-md-4 d-flex justify-content-center text-center">
            <HomeUserDescription
              title="LEARN MORE"
              link="/tutorial/1"
              buttonName="Tutorial"
              description="If you are new to cellular automata modeling and its application to developmental neurobiology, and would like to learn more, click here."
            />
          </div>
          <div className="col-md-4 d-flex justify-content-center text-center">
            <HomeUserDescription
              title="SIMULATOR"
              link="/neurosphere"
              buttonName="Simulator"
              description="If you would like to go directly to the Neurosphere Simulator, click here."
            />
          </div>
          <div className="col-md-4 d-flex justify-content-center text-center">
            <HomeUserDescription
              title="RESEARCH"
              link="http://www.northeastern.edu/neurobiology/research/"
              buttonName="Research"
              description="If you are interested in the research that led to the development of the Neurosphere Simulator, click here."
            />
          </div>
        </div>
      </div>
    );
  }
}
export default NoMatchPage;
